/* BACHCA - Upsell panier "Boite cadeau" : ajoute/retire le produit en 1 clic.
   Defini globalement (charge dans theme.liquid) car le contenu du drawer est
   injecte via innerHTML : un <script> inline dans la section ne s'executerait pas. */
if (!customElements.get('cart-upsell')) {
  customElements.define(
    'cart-upsell',
    class CartUpsell extends HTMLElement {
      connectedCallback() {
        this.miniCart = document.querySelector('mini-cart');
        this.checkbox = this.querySelector('.cart-upsell__checkbox');
        this.spinner = this.querySelector('.cart-upsell__spinner');
        this.variantId = this.dataset.variantId;
        if (this.checkbox && !this._bound) {
          this._bound = true;
          this.checkbox.addEventListener('change', this.onChange.bind(this));
        }
      }

      get sections() {
        return this.miniCart ? this.miniCart.getSectionsToRender().map((s) => s.id) : [];
      }

      config() {
        if (typeof fetchConfig === 'function') return fetchConfig('javascript');
        return {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        };
      }

      loading(state) {
        this.classList.toggle('is-loading', state);
        if (this.spinner) this.spinner.classList.toggle('hidden', !state);
        if (this.checkbox) this.checkbox.disabled = state;
      }

      onChange() {
        if (this.checkbox.checked) this.changeQuantity(1, window.routes && window.routes.cart_add_url);
        else this.changeQuantity(0, window.routes && window.routes.cart_change_url);
      }

      changeQuantity(quantity, route) {
        this.loading(true);
        const url = route || (quantity > 0 ? '/cart/add.js' : '/cart/change.js');
        const body = JSON.stringify({
          id: this.variantId,
          quantity: quantity,
          sections: this.sections,
          sections_url: window.location.pathname,
        });

        fetch(url, { ...this.config(), body })
          .then((r) => r.json())
          .then((state) => {
            if (state.status) {
              this.revert();
              return;
            }
            if (this.miniCart) this.miniCart.renderContents(state);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          })
          .catch(() => this.revert())
          .finally(() => this.loading(false));
      }

      revert() {
        if (this.checkbox) this.checkbox.checked = !this.checkbox.checked;
      }
    }
  );
}
